import React from 'react';
import UndsenMedeelel from './undsenHurunguMedeelel';

const PageList = () => <UndsenMedeelel />;

export default PageList;
